import React, {
    useContext,
} from "react"

import Table from "react-bootstrap/Table"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import "./style.css"

export type EMETLTableProps = {
    headers: string[],
    rows: {
        title: (string | number | boolean),
        subtitle?: string,
    }[][],
    onSelectCell?: (item: {
        title: (string | number | boolean),
        subtitle?: string,
    }[]) => void,
    hideColumns?: number[],
}

const EMETLTable = (props: EMETLTableProps) => {
    const {
        mode,
    } = useContext(Context)

    const {
        headers,
        rows,
        onSelectCell,
        hideColumns = [],
    } = props

    return (
        <Table 
            striped hover
        >
            <thead>
                <tr>
                    {headers?.filter((_h: string, i: number) => !hideColumns.includes(i))
                        .map((h: string, i: number) => (
                            <th 
                                key={i}
                                className="text-secondary header"
                            >
                                {h}
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    !!rows?.length && rows.map(
                        (item: {
                            title: (string | number | boolean),
                            subtitle?: string,
                        }[], row: number) => (
                            <tr
                                key={`${item[0].title as string}_${row}`}
                                onClick={() => onSelectCell && onSelectCell(item)}
                                className="tableRow"
                            >
                                {Object.keys(item).filter((_, i: number) => !hideColumns.includes(i))
                                    .map((key: string, column: number) => (
                                        <td
                                            key={`${key}_${column}`}
                                            className="cell"
                                        >
                                            <div
                                                className="text-secondary"
                                            >
                                                {`${item[key]?.title}`}
                                            </div>
                                            <small 
                                                className="text-muted subtitle"
                                            >
                                                {`${item[key]?.subtitle?.replace(/,/g, " ") ?? ""}`}
                                            </small>
                                        </td>
                                    ))
                                }
                            </tr>
                        )
                    )
                }
            </tbody>
        </Table>
    )
}

export default EMETLTable
